import * as R from "ramda";
import { getGradient, getSize } from "views/resources/theme";
import React from "react";
import styled from "styled-components";

const bgcolor = ({
	theme,
	color,
	gradient,
	disabled,
	isLoading,
	invertedColor,
}) => {
	if (invertedColor) return theme.colors.fg_alt;
	if (disabled && isLoading) return theme.colors[color];
	if (disabled) return theme.colors["disabled"];
	if (gradient) return getGradient(gradient)({ theme });
	return theme.colors[color];
};

// FIXME this color is hardcoded
const fgcolor = ({ theme, invertedColor, color }) => {
	//if (color) return theme.colors[color];
	if (invertedColor) return theme.colors.secondary;
	return theme.colors.fg_alt;
};

const size = ({ size, theme }) => {
	return size === "full" ? `100%` : "auto";
};

const fsize = ({ size, theme }) => {
	return size === "full" ? `18px` : "inherit";
};

const padding = ({ size, theme }) => {
	return size === "full" ? `5px` : "0 5px";
};

const height = ({ size, theme }) => {
	return size === "full" ? `48px` : "38px";
};

const loadingPointer = ({ isLoading }) => (isLoading ? "wait" : "pointer");

const hover_color = ({ color, isLoading, theme, invertedColor }) => {
	const orig_color = R.path(["colors", color], theme);
	const scolor = R.pathOr(orig_color, ["colors", color + "_light"], theme);
	if (invertedColor) return theme.colors.fg_alt;
	return isLoading ? "" : scolor;
};

export const PrimaryButton = styled.input.attrs((props) => ({
	type: "submit",
	value: props.value,
}))`
	height: ${height};
	width: 136px;
	background-color: #145ab4;
	border: none;
	color: #fff;
	border-radius: 3px;
	display: block;
	${(props) => props.centered && "margin: 55px auto;"}
`;

export const Wrapper = styled.button`
	background: ${bgcolor};
	color: ${fgcolor};
	width: ${size};
	font-size: ${fsize};
	height: ${height};
	min-width: 136px;
	border: none;
	margin: 0 4px;
	padding: 0 5px;
	line-height: ${height};
	cursor: ${loadingPointer};
	border-radius: ${getSize("xs")};
	overflow: hidden;

	&:hover {
		background-color: ${hover_color};
	}
`;
